import React, { useState, useEffect } from "react";
import { Typography, Chip, Avatar, Tooltip } from "@mui/material";
import CustomTable from "../../../components/Table/Table";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
// import AddClient from "../AddClient/AddClient";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { useLoading } from "../../../contexts/LoadingContext";
import Modal from "../../../components/Modal/Modal";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import BusinessIcon from "@mui/icons-material/Business";
import { useAllProjectMilestoneViewModel } from "../../ProjectMilestone/ProjectMilestoneAll/AllProjectMilestoneViewModel.js";
import AddProjectMilestone from "../../ProjectMilestone/AddProjectMilestone/AddProjectMilestone.js";
import { useRbac } from "../../../hooks/RbacContext";
import { getEnumLabel } from "../../../utils/enumUtils";
import { useParams } from "react-router-dom";
import { useAllDeliverableViewModel } from "./AllDeliverableViewModel.js";
import AddProjectDeliverable from "./AddProjectDeliverable.js";
import DoneIcon from "@mui/icons-material/Done";
import { grey, green } from "@mui/material/colors";
const AllMilestoneByProject = () => {
  const {
    projectMilestones,
    resources,
    projects,
    loading,
    error,
    getResourceName,
    getProjectName,
    createProjectMilestone,
    updateProjectMilestone,
    handleDelete,
    refetch,
    roles,
    getRoleName,
    milestoneMinDate,
    milestoneMaxDate,
  } = useAllProjectMilestoneViewModel();
  const { showLoading, hideLoading } = useLoading();
  const [isAddProjectMilestoneOpen, setIsAddProjectMilestoneOpen] =
    useState(false);
  const [isAddMilestoneDeliverableOpen, setIsAddMilestoneDeliverableOpen] =
    useState(false);
  const [selectedProjectMilestone, setSelectedProjectMilestone] =
    useState(null);
  const [selectedProjectDeliverable, setSelectedProjectDeliverable] =
    useState(null);
  const [successModal, setSuccessModal] = useState(null);
  const [deleteConfirmation, setDeleteConfirmation] = useState(null);
  const [deleteDeliverableConfirmation, setDeleteDeliverableConfirmation] =
    useState(null);
  const [deliverableStatusConfirmation, setDeliverableStatusConfirmation] =
    useState(null);
  const { hasProjectPermission, checkAccess } = useRbac();
  const projectId = useParams()?.id;
  const [dateRangeValue, setDateRangeValue] = useState([null, null]);
  const {
    // refetchDeliverables,
    fetchSubData,
    milestones,
    getMilestoneName,
    updateProjectDeliverable,
    createProjectDeliverable,
    handleDelete: handleDeleteDeliverable,
  } = useAllDeliverableViewModel();
  const columns = [
    // {
    //     id: "project_id",
    //     label: "Project",
    //     render: (value) => (
    //         <Typography
    //             variant="body2"
    //             noWrap
    //             sx={{
    //                 fontSize: "inherit",
    //                 color: (theme) =>
    //                     value ? theme.palette.text.primary : theme.palette.text.secondary,
    //             }}
    //         >
    //             {getProjectName(value)}
    //         </Typography>
    //     ),
    //     searchValue: (value) => getProjectName(value),
    // },
    {
      id: "milestone_code",
      label: "ML Code",
      align: "left",
      render: (value) => (
        <Tooltip
          title={value || ""}
          arrow
          placement="top"
          PopperProps={{
            sx: {
              "& .MuiTooltip-tooltip": {
                textAlign: "center",
              },
            },
          }}
        >
          <Typography
            sx={{
              width: "100px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontSize: "12px",
              display: "block",
            }}
          >
            {value}
          </Typography>
        </Tooltip>
      ),
    },
    {
      id: "milestone_name",
      label: "Title",
      align: "left",
      render: (value) => (
        <Tooltip
          title={value || ""}
          arrow
          placement="top"
          PopperProps={{
            sx: {
              "& .MuiTooltip-tooltip": {
                textAlign: "center",
              },
            },
          }}
        >
          <Typography
            sx={{
              width: "120px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontSize: "12px",
              display: "block",
            }}
          >
            {value}
          </Typography>
        </Tooltip>
      ),
    },
    {
      id: "milestone_description",
      label: "Description",
      align: "left",
      render: (value) => (
        <Tooltip
          title={value || ""}
          arrow
          placement="top"
          PopperProps={{
            sx: {
              "& .MuiTooltip-tooltip": {
                textAlign: "center",
              },
            },
          }}
        >
          <Typography
            sx={{
              width: "120px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontSize: "12px",
              display: "block",
            }}
          >
            {value}
          </Typography>
        </Tooltip>
      ),
    },
    {
      id: "milestone_start_date",
      label: "Start Date",
      align: "left",
      render: (value) => {
        if (!value) return "-";
        const date = new Date(value);
        return date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
      },
    },
    {
      id: "milestone_end_date",
      label: "End Date",
      align: "left",
      render: (value) => {
        if (!value) return "-";
        const date = new Date(value);
        return date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
      },
    },
    {
      id: "milestone_status_code",
      label: "Status",
      render: (value) => getEnumLabel("milestone_status_code", value),
      align: "left",
    },
  ];
  const [expandedRows, setExpandedRows] = useState({});
  const [subData, setSubData] = useState([{}]);
  const [dateFilterOpen, setDateFilterOpen] = useState(null);
  const [isExpandingAll, setIsExpandingAll] = useState(false);
  const [filteredMilestoneData, setFilteredMilestoneData] = useState([]);
  const [showAddButton, setShowAddButton] = useState(true);
  const [projectPublish, setProjectPublish] = useState(false);
  useEffect(() => {
    const projectDetails = projects.filter(
      (project) => project.project_id === projectId
    );

    const projectMilestoneDetails = projectMilestones.filter(
      (milestone) => milestone.publish_type === "PUBLISHED"
    );
    if (
      projectMilestoneDetails?.length > 0 &&
      projectDetails[0]?.publish_type === "APPROVED"
    )
      setShowAddButton(false);
    setProjectPublish(projectDetails[0]?.publish_type === "APPROVED");
    setFilteredMilestoneData(projectMilestones);
  }, [projectMilestones, showAddButton]);

  const handleRowExpand = async (row, isExpanded) => {
    const newExpandedRows = { ...expandedRows, [row.milestone_id]: isExpanded };
    setExpandedRows(newExpandedRows);
    if (isExpanded) {
      try {
        setSubData({ [row.milestone_id]: row.deliverables });
      } catch (error) {
        console.error("Error fetching deliverables:", error);
      }
    }
  };
  const handleExpandAll = async (expand) => {
    setIsExpandingAll(!isExpandingAll);
    const newExpandedRows = {};
    filteredMilestoneData.forEach((row) => {
      newExpandedRows[row.milestone_id] = expand;
    });
    setExpandedRows(newExpandedRows);
  };
  const expandableColumns = [
    {
      id: "deliverable_code",
      label: "DL Code",
      align: "left",
      render: (value) => (
        <Tooltip
          title={value || ""}
          arrow
          placement="top"
          PopperProps={{
            sx: {
              "& .MuiTooltip-tooltip": {
                textAlign: "center",
              },
            },
          }}
        >
          <Typography
            sx={{
              width: "100px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontSize: "12px",
              display: "block",
            }}
          >
            {value}
          </Typography>
        </Tooltip>
      ),
    },
    {
      id: "deliverable_name",
      label: "Deliverable Title",
      align: "left",
      render: (value) => (
        <Tooltip title={value || ""} arrow placement="top">
          <Typography
            sx={{
              width: "120px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontSize: "12px",
            }}
          >
            {value}
          </Typography>
        </Tooltip>
      ),
    },
    {
      id: "deliverable_status_code",
      label: "Status",
      render: (value, row) => {
        const isInProgress = value === "IN_PROGRESS";
        return (
          <Tooltip title={isInProgress ? "Not Completed" : "Completed"} arrow>
            <DoneIcon
              sx={{
                color: isInProgress ? grey[500] : green[500],
                cursor: isInProgress ? "pointer" : "default",
              }}
              onClick={
                isInProgress ? () => handleStatusDeliverable(row) : undefined
              }
            />
          </Tooltip>
        );
      },
      align: "left",
    },
  ];
  const fixedColumns = {
    left: [],
    right: ["is_active", "actions"],
  };
  const getExpandableRowData = (row) => {
    return row.deliverables || [];
  };
  const handleAddClient = () => {
    setSelectedProjectMilestone({
      project_id: projectId,
      milestone_min_date: milestoneMinDate,
      milestone_max_date: milestoneMaxDate,
    });
    setIsAddProjectMilestoneOpen(true);
  };
  const handleAddDeliverable = (row) => {
    setIsAddMilestoneDeliverableOpen(true);
    setSelectedProjectDeliverable({
      milestone_id: row.milestone_id,
      milestone_name: row.milestone_name,
    });
  };

  const handleEditClient = (client) => {
    setSelectedProjectMilestone(client);
    setIsAddProjectMilestoneOpen(true);
  };
  const handleEditDeliverable = (deliverable) => {
    setIsAddMilestoneDeliverableOpen(true);
    setSelectedProjectDeliverable(deliverable);
  };
  const handleCloseDialog = () => {
    setIsAddProjectMilestoneOpen(false);
    setSelectedProjectMilestone(null);
  };
  const handleCloseDialogDeliverable = () => {
    setIsAddMilestoneDeliverableOpen(false);
    setSelectedProjectDeliverable(null);
  };
  const handleSubmit = async (formData) => {
    try {
      showLoading();
      if (selectedProjectMilestone?.milestone_id) {
        await updateProjectMilestone(selectedProjectMilestone, formData);
        setSuccessModal({
          type: "success",
          title: "Success",
          message: "Project Milestone updated successfully",
        });
      } else {
        await createProjectMilestone(formData);
        setSuccessModal({
          type: "success",
          title: "Success",
          message: "Project Milestone added successfully",
        });
      }
      handleCloseDialog();
      await refetch();
    } catch (error) {
      throw error;
    } finally {
      hideLoading();
    }
  };
  const handleSubmitDeliverable = async (formData) => {
    try {
      showLoading();
      if (selectedProjectDeliverable?.deliverable_id) {
        await updateProjectDeliverable(selectedProjectDeliverable, formData);
        setSuccessModal({
          type: "success",
          title: "Success",
          message: "Project Deliverable updated successfully",
        });
      } else {
        await createProjectDeliverable(formData);
        setSuccessModal({
          type: "success",
          title: "Success",
          message: "Project Deliverable added successfully",
        });
      }
      handleCloseDialogDeliverable();
      // await refetchDeliverables();
    } catch (error) {
      throw error;
    } finally {
      hideLoading();
    }
  };

  const handleCloseSuccessModal = () => {
    setSuccessModal(null);
  };

  const handleDeleteClick = (projectResourceMapping) => {
    setDeleteConfirmation({
      projectResourceMapping,
      open: true,
    });
  };
  const handleDeleteDeliverableClick = (projectDeliverable) => {
    setDeleteDeliverableConfirmation({
      projectDeliverable,
      open: true,
    });
  };
  const handleStatusDeliverable = (deliverable) => {
    setDeliverableStatusConfirmation({
      deliverable,
      open: true,
    });
  };
  const handleDeleteConfirm = async () => {
    const projectResourceMapping = deleteConfirmation.projectResourceMapping;
    try {
      showLoading();
      await handleDelete(projectResourceMapping);
      setDeleteConfirmation(null);
      setSuccessModal({
        type: "success",
        title: "Success",
        message: "Project Milestone deleted successfully",
      });
    } catch (error) {
      setDeleteConfirmation(null);
      setSuccessModal({
        type: "error",
        title: "Action Failed",
        message: error?.message || "Failed to delete Project Milestone",
      });
    } finally {
      hideLoading();
    }
  };
  const handleDeleteDeliverableConfirm = async () => {
    const projectDeliverable = deleteDeliverableConfirmation.projectDeliverable;
    try {
      showLoading();
      await handleDeleteDeliverable(projectDeliverable);
      setDeleteDeliverableConfirmation(null);
      setSuccessModal({
        type: "success",
        title: "Success",
        message: "Project Deliverable deleted successfully",
      });
    } catch (error) {
      setSuccessModal({
        type: "error",
        title: "Error",
        message: error.message || "Failed to delete Project Milestone",
      });
    } finally {
      hideLoading();
    }
  };
  const handleDeliverableStatusConfirm = async () => {
    const projectDeliverable = deliverableStatusConfirmation.deliverable;
    try {
      showLoading();
      await updateProjectDeliverable(projectDeliverable, {
        ...projectDeliverable,
        deliverable_status_code: "COMPLETE",
      });
      setDeliverableStatusConfirmation(null);
      setSuccessModal({
        type: "success",
        title: "Success",
        message: "Project Deliverable status changed successfully",
      });
      setTimeout(() => {
        setSuccessModal(null);
      }, 1000);
    } catch (error) {
      setSuccessModal({
        type: "error",
        title: "Error",
        message: error.message || "Failed to update Deliverable status",
      });
    } finally {
      hideLoading();
    }
  };

  const getActions = (milestone) => {
    const actions = [];
    if (
      hasProjectPermission(parseInt(projectId), "milestones", "update") ||
      checkAccess("projectMilestones", "update")
    ) {
      actions.push({
        icon: <EditIcon fontSize="small" />,
        label: "Edit",
        onClick: handleEditClient,
        color: "primary",
        disabled:
          milestone?.milestone_status_code === "COMPLETE" ||
          !showAddButton ||
          !checkAccess("projectMilestones", "update"),
        sx: {
          "&:hover": {
            backgroundColor: (theme) =>
              theme.palette.primary.lighter || "rgba(33, 150, 243, 0.08)",
          },
        },
      });
    }
    if (
      hasProjectPermission(parseInt(projectId), "milestones", "delete") ||
      checkAccess("projectMilestones", "delete")
    ) {
      actions.push({
        icon: <DeleteIcon fontSize="small" />,
        label: "Delete",
        onClick: handleDeleteClick,
        color: "error",
        disabled:
          milestone?.milestone_status_code === "COMPLETE" ||
          !checkAccess("projectMilestones", "delete") ||
          !showAddButton,
        sx: {
          "&:hover": {
            backgroundColor: (theme) =>
              theme.palette.error.lighter || "rgba(26, 26, 26, 0.08)",
          },
        },
      });
    }

    return actions;
  };
  const getSubActions = (deliverable) => {
    const actions = [];
    if (
      hasProjectPermission(parseInt(projectId), "deliverables", "update") ||
      checkAccess("projectDeliverables", "update")
    ) {
      actions.push({
        icon: <EditIcon fontSize="small" />,
        label: "Edit",
        onClick: handleEditDeliverable,
        color: "primary",
        disabled: deliverable?.deliverable_status_code === "COMPLETE",
        sx: {
          "&:hover": {
            backgroundColor: (theme) =>
              theme.palette.primary.lighter || "rgba(33, 150, 243, 0.08)",
          },
        },
      });
    }
    if (
      hasProjectPermission(parseInt(projectId), "deliverables", "delete") ||
      checkAccess("projectDeliverables", "delete")
    ) {
      actions.push({
        icon: <DeleteIcon fontSize="small" />,
        label: "Delete",
        onClick: handleDeleteDeliverableClick,
        color: "error",
        disabled: deliverable?.deliverable_status_code === "COMPLETE",
        sx: {
          "&:hover": {
            backgroundColor: (theme) =>
              theme.palette.error.lighter || "rgba(26, 26, 26, 0.08)",
          },
        },
      });
    }

    return actions;
  };

  if (error) {
    return (
      <div>
        <Typography color="error">Error: {error}</Typography>
      </div>
    );
  }
  const columnFilters = [
    {
      id: "project_id",
      type: "select",
      label: "Project",
      render: (value) => getProjectName(value),
      icon: <BusinessIcon />,
      sendIcon: true,
    },
  ];

  const handleFilterDateClick = (event) => {
    setDateFilterOpen(event.currentTarget); // Open filter popover
  };

  const handleCloseDateChangeFilter = () => {
    setDateFilterOpen(null);
  };
  const handleClearDateFilter = () => {
    setFilteredMilestoneData(projectMilestones);
    setDateRangeValue([null, null]);
  };

  const handleDateChangeFilter = (dates) => {
    setDateRangeValue(dates);
    // handleCloseDateChangeFilter();
    onFilter(dates); // Apply filtering
  };

  // Function to filter data based on selected range
  const onFilter = ([start, end]) => {
    if (!start || !end) {
      setFilteredMilestoneData(projectMilestones);
      return;
    }
    const startDateStr = start.toISOString().split("T")[0];
    const endDateStr = end.toISOString().split("T")[0];

    const filteredData = projectMilestones.filter((row) => {
      const milestoneStart = row.milestone_start_date
        ? row.milestone_start_date.split("T")[0]
        : null; // Already in YYYY-MM-DD format
      const milestoneEnd = row.milestone_end_date
        ? row.milestone_end_date.split("T")[0]
        : null; // Already in YYYY-MM-DD format
      if (!milestoneStart || !milestoneEnd) return true;
      return (
        (milestoneStart >= startDateStr && milestoneStart <= endDateStr) ||
        (milestoneEnd >= startDateStr && milestoneEnd <= endDateStr) ||
        (milestoneStart <= startDateStr && milestoneEnd >= endDateStr)
      );
    });
    setFilteredMilestoneData(filteredData);
  };
  return (
    <div>
      <CustomTable
        columns={columns}
        data={filteredMilestoneData}
        onAdd={handleAddClient}
        showActions={true}
        showAddButton={
          hasProjectPermission(parseInt(projectId), "milestones", "add") ||
          checkAccess("projectMilestones", "add")
        }
        addButtonDisable={!showAddButton}
        setAddButtonDisable={setShowAddButton}
        addButtonIcon={<PersonAddIcon />}
        showSubAddButton={
          hasProjectPermission(parseInt(projectId), "deliverables", "add") ||
          checkAccess("projectDeliverables", "add")
        }
        subTableButton="Add Deliverable"
        showExpandableRows={true}
        showDateFilter={true}
        dateFilterOpen={dateFilterOpen}
        dateRangeValue={dateRangeValue}
        minDate={milestoneMinDate}
        maxDate={milestoneMaxDate}
        handleClearDateFilter={handleClearDateFilter}
        handleCloseDateChangeFilter={handleCloseDateChangeFilter}
        handleFilterDateClick={handleFilterDateClick}
        handleDateChangeFilter={handleDateChangeFilter}
        expandedRowRender={getExpandableRowData}
        expandableRowColumns={expandableColumns}
        expandedRows={expandedRows}
        onRowExpand={handleRowExpand}
        onAddSubRow={handleAddDeliverable}
        showSearch={false}
        showColumnVisibility={false}
        pageSize={10}
        stickyHeader={true}
        fixedColumns={fixedColumns}
        actions={getActions}
        showSubActions={true}
        subActions={getSubActions}
        title="Milestones & Deliverables"
        subtitle=""
        addButtonText="Add Milestone"
        alignment="left"
        fontSize="12px"
        showFilters={false}
        columnFilters={columnFilters}
        onExpandAll={handleExpandAll}
        publishMilestoneButton={projectPublish}
      />

      <AddProjectMilestone
        open={isAddProjectMilestoneOpen}
        onClose={handleCloseDialog}
        initialData={selectedProjectMilestone}
        onSubmit={handleSubmit}
        resources={resources}
        getResourceName={getResourceName}
        projects={projects}
        getProjectName={getProjectName}
        roles={roles}
      />
      <AddProjectDeliverable
        open={isAddMilestoneDeliverableOpen}
        onClose={handleCloseDialogDeliverable}
        initialData={selectedProjectDeliverable}
        onSubmit={handleSubmitDeliverable}
        milestones={milestones}
        getMilestoneName={getMilestoneName}
      />

      {successModal && (
        <Modal
          type={successModal.type}
          title={successModal.title}
          message={successModal.message}
          onClose={handleCloseSuccessModal}
        />
      )}

      {deleteConfirmation && (
        <ConfirmationModal
          open={true}
          title="Delete Project Milestone"
          message={`Are you sure you want to delete Project Milestone "${deleteConfirmation.projectResourceMapping.milestone_name}"?`}
          onClose={() => setDeleteConfirmation(null)}
          onConfirm={handleDeleteConfirm}
        />
      )}
      {deleteDeliverableConfirmation && (
        <ConfirmationModal
          open={true}
          title="Delete Project Deliverable"
          message={`Are you sure you want to delete Project Deliverable "${deleteDeliverableConfirmation.projectDeliverable.deliverable_name}"?`}
          onClose={() => setDeleteDeliverableConfirmation(null)}
          onConfirm={handleDeleteDeliverableConfirm}
        />
      )}
      {deliverableStatusConfirmation && (
        <ConfirmationModal
          open={true}
          title="Update Project Deliverable Status"
          message={`Are you sure you want to update Project Deliverable status of "${deliverableStatusConfirmation?.deliverable?.deliverable_name}"?`}
          onClose={() => setDeliverableStatusConfirmation(null)}
          onConfirm={handleDeliverableStatusConfirm}
          buttonText="Update"
        />
      )}
    </div>
  );
};

export default AllMilestoneByProject;
